var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgParking = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Parking-P-1--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Parking P 1 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.51 21.25h-4a0.25 0.25 0 0 0 -0.25 0.25v0.25a2.25 2.25 0 0 0 4.5 0v-0.25a0.25 0.25 0 0 0 -0.25 -0.25Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.51 21.25h-4a0.25 0.25 0 0 0 -0.25 0.25v0.25a2.25 2.25 0 1 0 4.5 0v-0.25a0.25 0.25 0 0 0 -0.25 -0.25Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.49 3.25h-1.25v2.5h1.25a1.25 1.25 0 0 0 0 -2.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 0a6 6 0 1 0 6 6 6 6 0 0 0 -6 -6Zm0.5 7.25h-1.26V9.5a0.75 0.75 0 1 1 -1.5 0v-7a0.75 0.75 0 0 1 0.75 -0.75h2a2.75 2.75 0 0 1 0 5.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.72 14.13a0.23 0.23 0 0 1 -0.1 -0.19 0.26 0.26 0 0 1 0.1 -0.19l0.06 -0.05a0.24 0.24 0 0 0 0.08 -0.28 0.25 0.25 0 0 0 -0.23 -0.17H4.88a0.23 0.23 0 0 1 -0.18 -0.08 0.31 0.31 0 0 1 -0.07 -0.2l0.2 -1.8a1 1 0 0 1 1 -0.92h3.66a1 1 0 1 0 0 -2H5.83a3 3 0 0 0 -3 2.73l-0.1 0.88a0.24 0.24 0 0 1 -0.4 0.17l-0.7 -0.56A1 1 0 1 0 0.39 13l0.88 0.71a0.25 0.25 0 0 1 0.09 0.19 0.22 0.22 0 0 1 -0.09 0.2 2.74 2.74 0 0 0 -1 2.12v2.28A1.75 1.75 0 0 0 2 20.25h17a1.75 1.75 0 0 0 1.75 -1.75v-2.25a2.76 2.76 0 0 0 -1.03 -2.12ZM4 18.5A1.5 1.5 0 1 1 5.51 17 1.5 1.5 0 0 1 4 18.5Zm13 0a1.5 1.5 0 1 1 1.5 -1.5 1.5 1.5 0 0 1 -1.5 1.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgParking);
export default ForwardRef;